import React, { memo } from 'react';
import { Outlet } from 'react-router-dom';
import { GlobalStyle } from 'theme';

import { useRouteBasedStyleProps } from '../hooks';

function GlobalStyleConnector() {
    const { isAlternativeBackground } = useRouteBasedStyleProps();

    return (
        <>
            <GlobalStyle alternativeBackground={ isAlternativeBackground } />
            <Outlet />
        </>
    );
}

export default memo(GlobalStyleConnector);
